import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";

import {BingMapMarker} from "../../bing-maps/bing-map-marker";

@Injectable({
  providedIn: 'root'
})
export class ObjectDetailService {

  private baseUrl = "apiUrl";

  libraryClick = new EventEmitter();

  onlineVersionClick = new EventEmitter();

  constructor(private http: HttpClient) {
  }

  getLibrariesWork(materializationIds: string[], userLocation?: BingMapMarker) {
    let params = {};
    if (userLocation && userLocation.lon && userLocation.lat) {
      params = {
        lat: userLocation.lat,
        lon: userLocation.lon
      }
    }
    return this.http.post(`${this.baseUrl}/omnis/search/item/query/materializations`, materializationIds, {params: params});
  }

}
